// Centralized endpoints for Canhoto Simples' existing Django API.
// Build paths here to avoid hardcoding strings across the codebase.

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export const endpoints = {
  auth: {
    token: () => `/v1/auth/token/`,
    refresh: () => `/v1/auth/refresh/`,
    register: () => `/v1/auth/register/`,
    invitation: () => `/v1/auth/invitations/`,
    passwordReset: () => `/v1/auth/password-reset/`,
    passwordResetConfirm: () => `/v1/auth/password-reset/confirm/`,
  },
  user: {
    preferences: (userId: number | string) => `/v1/user/users/${userId}/preferences/`,
    changePassword: () => `/v1/user/users/change-password/`,
    notifications: () => `/v1/notification/notifications/`,
  },
  account: {
    legal: () => `/v1/accounts/me/account/legal/`,
    cancellation: () => `/v1/accounts/me/account/cancellation/`,
    dataExport: () => `/v1/accounts/me/account/data-export/`,
    support: () => `/v1/support/account/`,
    plan: () => `/v1/accounts/me/account/`,
    memberships: () => `/v1/accounts/me/account/memberships/`,
    membership: (membershipId: string) => `/v1/accounts/me/account/memberships/${membershipId}/`,
    membershipResetPassword: (membershipId: string) => `/v1/accounts/me/account/memberships/${membershipId}/reset-password/`,
    operationsDashboard: () => `/v1/accounts/me/account/operations/dashboard/`,
    deliverySummary: () => `/v1/accounts/me/account/reports/summary/`,
    deliveryReport: () => `/v1/accounts/me/account/reports/deliveries/`,
    settings: () => `/v1/accounts/me/account/settings/`,
    billingOverview: () => `/v1/financial/me/account/billing/overview/`,
    billingOrders: () => `/v1/financial/me/account/billing/orders/`,
    billingOrder: (orderId: string) => `/v1/financial/me/account/billing/orders/${orderId}/`,
    billingPaymentAction: (orderId: string) => `/v1/financial/me/account/billing/orders/${orderId}/payment-action/`,
    billingRefresh: (orderId: string) => `/v1/financial/me/account/billing/orders/${orderId}/refresh/`,
    billingReceipt: (orderId: string) => `/v1/financial/me/account/billing/orders/${orderId}/receipt/`,
    billingCheckout: () => `/v1/financial/me/account/billing/subscription-checkout/`,
    billingPaymentMethodSession: () => `/v1/financial/me/account/billing/subscription/payment-method-session/`,
    billingCancelRenewal: () => `/v1/financial/me/account/billing/subscription/cancel-renewal/`,
    billingChangePlan: () => `/v1/financial/me/account/billing/subscription/change-plan/`,
    addons: () => `/v1/plan/me/addons`,
  },
  delivery: {
    list: () => `/v1/delivery/deliveries/`,
    detail: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/`,
    proofs: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/proofs/`,
    timeline: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/timeline/`,
    linkInvoice: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/link-invoice/`,
    receipt: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/receipt/`,
    assign: () => `/v1/delivery/deliveries/assign/`,
    reassign: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/reassign/`,
    fromInvoices: () => `/v1/delivery/deliveries/from-invoices/`,
    presign: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/presign/`,
    pods: () => `/v1/delivery/pods/`,
  },
  company: {
    list: () => `/v1/company/companies/`,
    detail: (companyId: string) => `/v1/company/companies/${companyId}/`,
    testSefaz: (companyId: string) => `/v1/company/companies/${companyId}/test-sefaz/`,
  },
  invoice: {
    list: () => `/v1/invoice/invoices/`,
    detail: (invoiceId: string) => `/v1/invoice/invoices/${invoiceId}/`,
    importXml: () => `/v1/invoice/invoices/import-xml/`,
    importRuns: () => `/v1/invoice/import-runs/`,
    importRun: (runId: string) => `/v1/invoice/import-runs/${runId}/`,
    importRunItems: (runId: string) => `/v1/invoice/import-runs/${runId}/items/`,
    retryImportRun: (runId: string) => `/v1/invoice/import-runs/${runId}/retry/`,
    generateDanfe: (invoiceId: string) => `/v1/invoice/invoices/${invoiceId}/generate-danfe/`,
  },
  public: {
    supportContact: () => `/v1/support/public-contact/`,
    plans: () => `/v1/plan/public/plans`,
    catalog: () => `/v1/plan/public/catalog`,
    proposals: () => `/v1/plan/public/proposals`,
    contact: () => `/v1/core/public/contact`,
    termsOfService: () => `/v1/core/terms-of-service/`,
    privacyPolicy: () => `/v1/core/privacy-policy/`,
  },
} as const
